angular.module('NiacsProjectApp.services-strategy', [
  'NiacsProjectApp.services-jsonapi',
  'ngResource'
])
.provider('$niacsStrategyResource',[function(){
    this.$get = ['$jsonApiResource','CacheService','$q',function($jsonApiResource,CacheService,$q){
        return function(strategy_resource,alias,title,disabled) {
            var cacheKey = 'Local_Strategies.'+strategy_resource;
            var Strat = $jsonApiResource('taxonomy_term',strategy_resource);
            Strat.prototype.$populateFromJsonApiResponse = function() {
                var atts = this.$jsonApi.data.attributes;
                this.name = atts.name;
                this.uuid = this.$jsonApi.data.id;
                this.id = atts.drupal_internal__tid;
                this.description = !!atts.description ?  atts.description.value : '';
                this.example = atts.field_approach_example;
                this.weight = atts.weight;
                if(!this.example || !this.example.length) {
                    delete this.example;
                }
                var parentRelationship = this.$jsonApi.data.relationships && this.$jsonApi.data.relationships.parent && this.$jsonApi.data.relationships.parent.data;
                if(parentRelationship && parentRelationship.length && !!parentRelationship[0] &&
                    !!parentRelationship[0].id && parentRelationship[0].id !== 'virtual') {
                    this.parentUuid = parentRelationship[0].id;
                }
            };
            Strat.getSourceAlias = function() { return alias; };
            Strat.getSource = function() { return strategy_resource; };
            Strat.getSourceTitle = function() { return title; };
            Strat.isDisabled = function() { return !!disabled; };
            // duplicate static functions onto instances of this type for ease of use
            Strat.prototype.getSourceAlias = Strat.getSourceAlias;
            Strat.prototype.getSource = Strat.getSource;
            Strat.prototype.getSourceTitle = Strat.getSourceTitle;
            Strat.prototype.isDisabled = Strat.isDisabled;

            // assumes no code will use the $promise on the result but will
            // always pass a callback
            Strat.query = (function(superFunc) {
                return function(p1,p2) {
                    var params,callback;
                    if(typeof(p1) === 'function') {
                        callback = p1;
                    } else {
                        params = p1;
                        callback = p2;
                    }
                    function callbackWrapper(listResponse) {
                        // root of hierarchy are strategies
                        // second level in hierarchy are approaches
                        var uuidMap = listResponse.list.reduce(function(map,d) {
                                map[d.uuid] = d;
                                return map;
                            },{});
                        listResponse.list = listResponse.list.reduce(function(arr,d) {
                                if(!!d.parentUuid) {
                                    // approach
                                    var parent = uuidMap[d.parentUuid];
                                    parent.approaches = parent.approaches||[];
                                    parent.approaches.push(d);
                                } else {
                                    // strategy
                                    arr.push(d);
                                }
                                return arr;
                            },[]);
                        var sortByWeight = function(a,b) {
                            return a.weight - b.weight;
                        };
                        listResponse.list.sort(sortByWeight);
                        listResponse.list.forEach(function(strat) {
                            strat.approaches.sort(sortByWeight);
                        });
                        // the legacy service directly returned an array, not a wrapped list response.
                        callback(listResponse.list);
                    }
                    // JSON API has a hard limit of 50 crawl full set if necessary
                    var page_limit=50;
                    var page_offset=0-page_limit;
                    params = params||{};
                    var lResponse = {list:[]};
                    var self = this;
                    var next = function() {
                        page_offset += page_limit;
                        params['page[offset]'] = page_offset;
                        params['page[limit]'] = page_limit;
                        superFunc.call(self,params,function(response) {
                            lResponse.list = lResponse.list.concat(response.list);
                            // got a full page back, see if there is any more
                            if(response.list.length === page_limit) {
                                next();
                            } else {
                                callbackWrapper(lResponse);
                            }
                        });
                    };
                    next();
                    // superFunc.call(this,params,callbackWrapper);
                };
            })(Strat.query);
            // "static" utility method that returns all strategies, from cache
            // if possible.  This method shrinks strategies to just id/name to
            // minimize their size on the wire.
            Strat.getAll = function() {
                var def = $q.defer(),
                    strats = CacheService.get(cacheKey);
                if(strats) {
                    def.resolve(strats);
                } else {
                    Strat.query(function(strategies){
                        CacheService.put(cacheKey,strategies);
                        def.resolve(strategies);
                    });
                }
                return def.promise;
            };
            return Strat;
        };
    }];
}])
.factory('StrategySource', ['$niacsStrategyResource','$jsonApiResource','$q',
    function($niacsStrategyResource,$jsonApiResource,$q) {
        var StrategySource = $jsonApiResource('taxonomy_term','strategy_source');
        StrategySource.prototype.$populateFromJsonApiResponse = function() {
            var atts = this.$jsonApi.data.attributes;
            this.alias = atts.field_taxonomy_alias;
            this.description = atts.description.processed;
            this.disabled = atts.field_sector_disabled;
            this.id = atts.drupal_internal__tid;
            this.resource = atts.field_taxonomy_machine_name;
            this.title = atts.name;
            //console.log('StrategySource.$populateFromJsonApiResponse',this);
        };
        StrategySource.getSourceList = function() {
            var def = $q.defer();
            StrategySource.query({},function(response) {
                def.resolve(response.list.map(function(source){
                    return $niacsStrategyResource(source.resource,source.alias,source.title,source.disabled);
                }));
            });
            return def.promise;
        };

        return StrategySource;
}])
.service('NiacsStrategyService',['$q','ProjectService','StrategySource',
    function($q,ProjectService,StrategySource){

        /** A simple class for interacting with the list of available strategies and approaches in the system. */
        function SourceTree(tree) {
            this.tree = tree;
            // build a flat list of strategies
            this.allStrategies = Object.keys(tree).reduce(function(arr,key) {
                    return arr.concat(tree[key].strategies);
                },[]);
        }

        /** @returns {Array} List of string enabled source machine names */
        SourceTree.prototype.getEnabledSourceNames = function() {
            return Object.keys(this.tree).sort();
        };

        /** @returns {Array} List of strategies for strategySourceName. */
        SourceTree.prototype.getStrategiesForSource = function(strategySourceName) {
            return this.tree[strategySourceName].strategies;
        };

        /** @returns {Strategy} Strategy object for strategyId. */
        SourceTree.prototype.getStrategy = function(strategyId) {
            return niacs.findById(this.allStrategies,strategyId);
        };

        /** @returns {StrategySource} For the given source name. */
        SourceTree.prototype.getSource = function(sourceName) {
            return this.tree[sourceName] ? this.tree[sourceName].source : undefined;
        };

        /** @returns {StrategySource} That a given strategy belongs to. */
        SourceTree.prototype.getStrategySource = function(strategyId) {
            var self = this;
            return Object.keys(this.tree).reduce(function(found,sn){
                if(!found) {
                    if(niacs.findById(self.tree[sn].strategies,strategyId)) {
                        found = self.tree[sn].source;
                    }
                }
                return found;
            },undefined);
        };

        /** @returns {Approach} Approach object for strategyId and approachId. */
        SourceTree.prototype.getApproach = function (strategyId,approachId) {
            var strategy = this.getStrategy(strategyId);
            return strategy && strategy.approaches ? niacs.findById(strategy.approaches,approachId) : undefined;
        };

        /** @returns {boolean} true if the strategy source name is associated with the project. */
        SourceTree.prototype.isDefaultSector = function(strategySourceName,project) {
            return !!project && !!strategySourceName ? project.strategy_sources.indexOf(strategySourceName.getSource()) !== -1 : false;
        };

        /** @returns {string} Label for a strategy (will include source title if not a default strategy). */
        SourceTree.prototype.getStrategyLabel = function(strategy,project) {
            var dfltSector = !!project ? this.isDefaultSector(strategy,project) : false; // assume not if we can't tell
            return strategy.name + (dfltSector ? '' : ' ('+strategy.getSourceTitle()+')');
        };
            
        var SOURCE_LIST = StrategySource.getSourceList(),
            SOURCE_TREE,
            service = {
                getSources: function() {
                    return SOURCE_LIST;
                },
                /**
                 * Fetches a tree of all available (enabled) sectors with their corresponding strategies
                 * wrapped in an object that allows for easy access to strategies and approaches (see SourceTree above).
                 */
                getSourceTree: function() {
                    if(!SOURCE_TREE) {
                        var def = $q.defer();
                        SOURCE_TREE = def.promise;

                        SOURCE_LIST.then(function(sources) {
                            /*
                            sources.forEach(function(s,i) {
                                var text = [['alias',s.getSourceAlias()],
                                 ['source',s.getSource()],
                                 ['sourceTitle',s.getSourceTitle()],
                                 ['disabled',s.isDisabled()]].map(function(arr){
                                    return arr[0]+'="'+arr[1]+'"';
                                 }).join(' ');
                                console.log('source['+i+'] '+text);
                            });
                            */
                            var enabledSources = sources.filter(function(s) { return !s.isDisabled(); });
                            $q.all(enabledSources.map(function(s) { return s.getAll(); }))
                              .then(function(strategies) {
                                  def.resolve(new SourceTree(enabledSources.reduce(function(map,s,i) {
                                    map[s.getSource()] = {
                                        source: s,
                                        strategies: strategies[i]
                                    };
                                    return map;
                                  },{})));
                              });
                        });
                    }
                    return SOURCE_TREE;
                },
                getProjectSourceResources: function(p) {
                    var def = $q.defer();
                    (p ? function(a,b,f) { return f(p); } : ProjectService.get)(undefined,undefined,function(project) {
                        SOURCE_LIST.then(function(sources){
                            var sources_map = sources.reduce(function(map,strat){
                                map[strat.getSource()] = strat;
                                return map;
                            },{});
                            var remainingSourceNames = sources
                                .filter(function(s) { return !s.isDisabled(); })
                                .map(function(s) { return s.getSource(); });
                            var projectSources = project.strategy_sources.map(function(source){
                                        remainingSourceNames = remainingSourceNames.filter(function(sn) { return sn !== source; });
                                        return sources_map[source];
                                    });
                            // previously the UI would only expose sector information that the project
                            // was associated with.  when the functionality was updated to allow for users
                            // to select strategies/approaches from any sector we now are just prioritizing
                            // the project sector up front and listing the others.
                            remainingSourceNames
                                // if far1 remains nix it
                                .filter(function(sn) { return sn !== 'niacs_strategy'; })
                                .forEach(function(sn) {
                                    projectSources.push(sources_map[sn]);
                                });
                            def.resolve(projectSources);
                        });
                    });
                    return def.promise;
                },
                /** @returns {Array} List of strategy sources that are in use by the project (or its default if none currently in use). */
                getUsedProjectSourceResources: function(p) {
                    var def = $q.defer();
                    service.getSourceTree().then(function(tree) {
                        var inUse = [];
                        (p.tactics||[]).forEach(function(tactic) {
                            (tactic.approaches||[]).forEach(function(a) {
                                var source = tree.getStrategySource(a.strategy);
                                if(source && inUse.indexOf(source)=== -1) {
                                    inUse.push(source);
                                }
                            });
                        });
                        if(!inUse.length) {
                            // project incomplete, supply the default project sector
                            inUse.push(tree.getSource(p.strategy_sources[0]));
                        }
                        def.resolve(inUse);
                    });
                    return def.promise;
                },
                // these next two functions are somewhat unfortunate since they require
                // specific knowledge about the system (sector machine names and/or caring
                // what sector a project is associated with)
                projectIsOnlyInSector: function(p,sector_machine_name) {
                    var def = $q.defer();
                    service.getProjectSourceResources(p).then(function(sources) {
                        // require the project to be exclusively in the given sector
                        // in case in the future the workbook functionality to allow
                        // projects in multiple sectors comes to fruition
                        def.resolve(sources && sources.length === 1 && sources[0].getSource() === sector_machine_name);
                    });
                    return def.promise;
                },
                projectIsOnlyAgriculture: function(p) {
                    return service.projectIsOnlyInSector(p,'niacs_strategy_ag');
                }
            };
        return service;
}]);
